@if (isVisible) {
<div class="form-preview" [data-testing]="'form-preview-overlay'">
    <div class="aix-viewer__action-bar aix-toolbar">
        <div class="form-preview__title">
            @if (formName()) {
            <span class="form-preview__title-text">Preview — {{ formName() }}</span>
            } @if (!formName()) {
            <span class="form-preview__title-text">Preview</span>
            }
        </div>

        <div class="aix-viewer__action-bar__container--right">
            <div
                class="aix-btn aix-btn--link br-link"
                [data-testing]="'form-preview-download'"
                (click)="onClickDownload()"
            >
                <i class="fa-regular fa-download u-mr4"></i> <span>Download</span>
            </div>
            <div
                class="aix-btn aix-btn--link br-link"
                [data-testing]="'form-preview-close'"
                (click)="close()"
            >
                <i class="fa-regular fa-xmark u-mr4"></i> <span>Close</span>
            </div>
        </div>
    </div>

    <div class="form-preview__body">
        <aix-notification
            [status]="'information'"
            [canClose]="true"
            [isOpen]="true"
            [data-testing]="'form-preview-saved-state-notice'"
        >
            This preview shows the answers currently on the form, including any you have not
            saved yet.
        </aix-notification>

        @if (isLoading) {
        <aix-loading [relative]="true"></aix-loading>
        } @if (loadFailed) {
        <div class="error-box" [data-testing]="'form-preview-error'">
            <div class="error-box__message">We're unable to generate a preview right now.</div>
            <div class="error-box__dev-message">
                Please try again, or contact support if the problem continues.
            </div>
            <div
                class="aix-btn aix-btn--link br-link u-mt8"
                [data-testing]="'form-preview-retry'"
                (click)="retry()"
            >
                Try again
            </div>
        </div>
        } @if (pdfDataSource && !loadFailed) {
        <div class="aix-viewer__document-wrapper" [data-testing]="'form-preview-pdf'">
            <div class="aix-viewer__document">
                <aix-pdf-viewer
                    [PDFJSready]="pdfJsReady"
                    [src]="pdfDataSource"
                    (loadDocumentError)="onLoadDocumentError($event)"
                >
                </aix-pdf-viewer>

                <div class="aix-viewer__controls-container">
                    <div class="aix-viewer__controls">
                        <div class="aix-viewer__controls-inner__left">
                            <div class="aix-viewer__icon-wrapper">
                                <a
                                    class="aix-viewer__zoom-out u-mt8"
                                    title="Zoom Out"
                                    (click)="zoomOut()"
                                >
                                    <i
                                        class="fa-regular fa-circle-minus aix-viewer__icon"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                            </div>
                            <div class="aix-viewer__icon-wrapper">
                                <a class="aix-viewer__rotate" title="Rotate" (click)="rotate()">
                                    <i
                                        class="fa-regular fa-rotate-right aix-viewer__icon"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                            </div>
                            <div class="aix-viewer__icon-wrapper">
                                <a class="aix-viewer__zoom-in" title="Zoom In" (click)="zoomIn()">
                                    <i
                                        class="fa-regular fa-circle-plus aria-hidden aix-viewer__icon"
                                        aria-hidden="true"
                                    ></i>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        }
    </div>
</div>
}
